import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 保存poitems文件
export function savePmsFile(file) {
  const data = new FormData()
  data.append('file', file)
  return request({
    url: URL.booking.savePmsFile,
    method: 'post',
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    data
  })
}

// PO货物明细
export function poItems(data) {
  return request({
    url: URL.seaExport.poItems,
    method: 'post',
    data: data
  })
}

// PO货物明细
export function getPoItemsByJobUuids(data) {
  return request({
    url: URL.seaExport.getPoItemsByJobUuids,
    method: 'post',
    data
  })
}

// PO货物明细更新保存
export function poItemsUpdate(data) {
  return request({
    url: URL.seaExport.poItemsUpdate,
    method: 'put',
    data
  })
}
